import { render, staticRenderFns } from "./StatisticsModuleCms.vue?vue&type=template&id=5ed0229d"
import script from "./StatisticsModuleCms.vue?vue&type=script&lang=ts"
export * from "./StatisticsModuleCms.vue?vue&type=script&lang=ts"
import style0 from "./StatisticsModuleCms.vue?vue&type=style&index=0&id=5ed0229d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports